import { Tag } from "antd"
import { replaceIdURL } from "../../../../helpers/replaceId";
import { ProjectRoot } from "../../../../router/type_router";
import { InmersysRoot } from "../../../../router/type_router";
import { changeDateTimeZone } from "../../../../helpers/dayjsHelper";

export const getColumns = (filters) => [
    {
        title: "Proyecto",
        dataIndex: "name",
        key: "name",
        render: (value, record) => {
            const urlId = replaceIdURL(ProjectRoot.selectproject, "id", record.clickupSpace);
            return (
                <a href={`${InmersysRoot.root}/${InmersysRoot.project}/${urlId}`} target="_blank" rel="noreferrer">
                    <span>{record.name}</span>
                </a>
            );
        },
        sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
        title: "Fecha de Inicio",
        dataIndex: "startedDate",
        key: "startedDate",
        render: (value) => {
            return <span>{changeDateTimeZone(value).dayLocal.format("DD/MMM/YYYY")}</span>
        },
        sorter: (a, b) => new Date(a.startedDate) - new Date(b.startedDate),    
    },
    {
        title: "Fecha de Cierre",
        dataIndex: "endFinishDate",
        key: "endFinishDate",
        render: (value) => {
            return <span>{changeDateTimeZone(value).dayLocal.format("DD/MMM/YYYY")}</span>
        },
        sorter: (a, b) => new Date(a.endFinishDate) - new Date(b.endFinishDate),
    },
    {
        title: "Semanas estimadas",
        dataIndex: "weeksComercial",
        key: "weeksComercial",
        sorter: (a, b) => a.weeksComercial - b.weeksComercial,
    },
    {
        title: "Semanas trabajadas",
        dataIndex: "weeksEquivalentStartAndEnd",
        key: "weeksEquivalentStartAndEnd",
        sorter: (a, b) => a.weeksEquivalentStartAndEnd - b.weeksEquivalentStartAndEnd,
    },
    {
        title: "Brecha entre semanas",
        dataIndex: "difference",
        key: "difference",
        render: (value) => {
            return <Tag color={value >= 0 ? "green" : "red"}>{value}</Tag>
        },
        sorter: (a, b) => a.difference - b.difference,
    },
    {
        title: "Tiene pausas",
        dataIndex: "hasPause",
        key: "hasPause",
        render: (value) => {
            return <Tag color={value ? "green" : "red"}>{value ? "Sí" : "No"}</Tag>
        }
    },
    {
        title: "Comercial",
        dataIndex: "comercial",
        key: "comercial",
        filters: filters.comercial.map((user) => ({ text: user.name, value: user.id })),
        onFilter: (value, record) => record.comercialTeam.some((user) => user.userId === value)
    },
    {
        title: "Lideres",
        dataIndex: "leaders",
        key: "leaders",
        filters: filters.leaders.map((user) => ({ text: user.name, value: user.id })),
        onFilter: (value, record) => record.leadersTeam.some((user) => user.userId === value)
    },
    {
        title: "Responsable",
        dataIndex: "responsible",
        key: "responsible",
        filters: filters.responsible.map((user) => ({ text: user.name, value: user.id })),
        onFilter: (value, record) => record.responsibleTeam.some((user) => user.userId === value)
    },
]